/* The funnel's 53 languages (contract 1.3 `Locale`, decisions 132 and 142), with what the first
   screen needs: the codes and the writing direction. Written out rather
   than imported from @delaybuddy/contract, whose `LOCALE_INFO` would bring zod into the
   production bundle; registry.test.ts holds the two equal. The scripts and their fonts are in
   ./scripts.ts and the names in ./names.ts: lazy chunks, for a switch and the sheet. */
import type { Locale } from '../../lib/api/contract';

export type { Locale };

/** English first, then by code: the contract's order. */
export const LOCALES = [
  'en',
  'ar',
  'bg',
  'bn',
  'bs',
  'cs',
  'da',
  'de',
  'el',
  'es',
  'et',
  'fa',
  'fi',
  'fil',
  'fr',
  'ga',
  'he',
  'hi',
  'hr',
  'hu',
  'id',
  'is',
  'it',
  'ja',
  'ka',
  'ko',
  'lt',
  'lv',
  'mk',
  'mt',
  'nb',
  'nl',
  'pa',
  'pl',
  'ps',
  'pt-PT',
  'ro',
  'ru',
  'sk',
  'sl',
  'sq',
  'sr-Cyrl',
  'sr-Latn',
  'sv',
  'ta',
  'th',
  'ti',
  'tr',
  'uk',
  'ur',
  'vi',
  'zh-Hans',
  'zh-Hant',
] as const satisfies readonly Locale[];

const SET: ReadonlySet<string> = new Set(LOCALES);
export const isLocale = (s: unknown): s is Locale => typeof s === 'string' && SET.has(s);

const RTL: ReadonlySet<Locale> = new Set(['ar', 'fa', 'he', 'ps', 'ur']);
export const dirOf = (l: Locale): 'ltr' | 'rtl' => (RTL.has(l) ? 'rtl' : 'ltr');

/** The code on the header's button: `DE`, `PT`, `ZH`, `SR` (the prototype's). */
export const shortCode = (l: Locale) => l.split('-')[0]!.toUpperCase();
